"use client";
import { LIST_MENU } from "@/constants";
import { cn } from "@/utils/utils";
import { useLocation, useNavigate } from "react-router-dom";

const DrawerMenu = () => {
  const { pathname } = useLocation();
  const navigation = useNavigate();

  return (
    <div className="w-1/5 max-w-[256px] max-lg:hidden">
      <div className="flex h-[164px] items-center justify-center">
        <div className="flex items-center gap-2.5">
          <img
            src="/images/logo.png"
            alt="logo"
            className="aspect-auto h-[48px] w-[134px] object-contain"
          />
          <div className="flex items-center rounded bg-[#E0E7FF] px-2 py-0.5">
            <span className="text-[10px] font-medium text-[#322F80]">
              SUPER-ADMIN
            </span>
          </div>
        </div>
      </div>
      {LIST_MENU.map((menu, index) => (
        <div key={index} className="ml-6">
          <button className="flex items-center justify-start gap-3 rounded-lg px-4 py-3 font-medium">
            <img src={menu.icon} alt={menu.title} />
            <span className="leading-[100%] text-text">{menu.title}</span>
          </button>

          {menu.children.map((tab, indexTab) => (
            <button
              key={indexTab}
              className={cn(
                "flex items-center justify-start gap-3 rounded-lg px-4 py-3 font-normal hover:opacity-80 lg:w-[232px]",
                {
                  "bg-button-background font-normal ": tab.screens.some(
                    (screen) => screen === pathname,
                  ),
                },
              )}
              onClick={() => navigation(tab.route)}
            >
              <div className="w-5" />
              <span className={cn("text-left text-sm text-text")}>
                {tab.title}
              </span>
            </button>
          ))}
        </div>
      ))}
    </div>
  );
};

export default DrawerMenu;
